<!-- plotter -->
<div *ngIf="printingService === 'plotter'" class="zx-tooltop-container rounded-2 d-flex flex-column gap-1 mx-2"
    [class.zx-tooltop-container-wide]="property === 'pricing'">
    <article *ngIf="property === 'pricing'" [class.zx-ltr]="!isRTL" [class.zx-text-white]="isDarkMode"
        class="w-100 d-flex flex-column gap-1 p-2 px-lg-4 zx-text-sm-white zx-text-small">
        <span class="pt-lg-2" [class.text-start]="!isRTL">
            {{ "printing-table.pricing.plotter.title" | translate }}:
        </span>
        <!-- unlisted list -->
        <ul class="zx-text-tiny pt-3 zx-text-sm-white fw-bold" [class.text-start]="!isRTL">
            <li class="zx-text-small pb-2">
                {{ "printing-table.pricing.plotter.param-1" | translate }}
            </li>
            <li class="zx-text-small pb-2">
                {{ "printing-table.pricing.plotter.param-2" | translate }}
            </li>
            <li class="zx-text-small">
                {{ "printing-table.pricing.plotter.param-3" | translate }}
            </li>
        </ul>
        <span class="pb-lg-2 pb-2" [class.text-start]="!isRTL">
            {{ "printing-table.pricing.plotter.explian-1" | translate }}
        </span>
        <span class="pb-lg-2" [class.text-start]="!isRTL">
            {{ "printing-table.pricing.plotter.explian-2" | translate }}
        </span>
    </article>
    <article *ngIf="property === 'paper'" class="w-100 d-flex flex-column gap-1">
        <div *ngFor="let inputBin of inputBins; let i = index" class="w-100 d-flex flex-column gap-1 p-2"
            [class.zx-border-top-gray-25-pr]="i !== 0" [class.align-items-end]="!isRTL"
            [class.zx-text-white]="isDarkMode">
            <!-- =========== title =========== -->

            <b class="zx-text-sm-white zx-text-small pb-1" [class.zx-ltr]="!isRTL" [class.zx-text-white]="isDarkMode">
                {{ "paper-type.name." + inputBin.paperType.paperType | translate }}
            </b>
            <!-- // =========== title =========== -->

            <!-- =========== paper =========== -->
            <div *ngIf="property === 'paper'" class="w-100 d-flex flex-column gap-1" [class.zx-text-white]="isDarkMode">
                <div class="w-100 d-flex align-items-center justify-content-between" [class.flex-row-reverse]="!isRTL">
                    <span class="zx-text-sm-white zx-text-tiny">
                        {{ "su-management.branches_paper-width" | translate }}
                    </span>
                    <span class="zx-text-sm-white zx-text-tiny" [class.zx-ltr]="!isRTL">
                        <span>
                            {{ inputBin.paperType.paperWidth / 1000 }}
                        </span>
                        <span>
                            {{ "printing-table.dimensions-cm" | translate }}
                        </span>
                    </span>
                </div>
                <div class="w-100 d-flex align-items-center justify-content-between" [class.flex-row-reverse]="!isRTL">
                    <span class="zx-text-sm-white zx-text-tiny">
                        {{ "su-management.branches_paper-weight" | translate }}
                    </span>
                    <span class="zx-text-sm-white zx-text-tiny" [class.zx-ltr]="!isRTL">
                        <span>
                            {{ inputBin.paperType.paperWeight }}
                        </span>
                        <span>
                            {{ "su-management.branches_paper-weight-g" | translate }}
                        </span>
                    </span>
                </div>
                <span class="zx-text-sm-white zx-text-tiny pt-1" [class.zx-ltr]="!isRTL" [class.text-start]="!isRTL">
                    {{ "paper-type.description." + inputBin.paperType.paperType | translate }}
                </span>
            </div>
            <!-- // =========== paper =========== -->

            <!-- =========== pricing =========== -->
            <!-- <div *ngIf="property === 'pricing'"
            class="w-100 d-flex flex-column align-items-center shadow-85 rounded-2 py-2 mt-2 px-3">
            <div *ngFor="let price of inputBin.paperType.pricingPoints" class="w-100 d-flex align-items-center pb-2"
                [class.flex-row-reverse]="!isRTL">
                <div class="d-flex flex-column gap-1 gap-lg-2">
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                        <span class="zx-text-tiny d-flex">
                            <span *ngIf="!isRTL">
                                {{ "printing-table.cover" | translate }}
                            </span>
                            <span *ngIf="!isRTL" class="zx-100-opp">-</span>
                            <span>%</span>
                            <span>
                                {{ price.min }}
                            </span>
                            <span>-</span>
                            <span>
                                {{ price.max }}
                            </span>
                            <span *ngIf="isRTL" class="zx-100-opp">-</span>
                            <span *ngIf="isRTL">
                                {{ "printing-table.cover" | translate }}
                            </span>
                        </span>
                    </div>
                </div>
                <div class="d-flex flex-column gap-1 gap-lg-2 flex-grow-1">
                    <span class="zx-text-sm-white zx-text-tiny d-flex justify-content-end"
                        [class.flex-row-reverse]="!isRTL" [class.zx-text-white]="isDarkMode">
                        <b>
                            {{ roundDownDecimal(price.price * .865) }}
                        </b>
                        <span class="zx-100-opp">-</span>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "printing-table.nis" | translate }}
                        </span>
                        <span class="zx-100-opp">-</span>
                        <span class="opacity-50 zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "su-management.report.prices.per-70-cm" | translate }}
                        </span>
                    </span>
                </div>
            </div> -->
        </div>
    </article>
</div>
<!-- express -->
<div *ngIf="printingService === 'express'" class="zx-tooltop-container rounded-2 d-flex flex-column gap-1 mx-2"
    [class.zx-tooltop-container-wide]="property === 'pricing'">
    <div *ngFor="let paper of printServicePapers; let i = index" class="w-100 d-flex flex-column gap-1 p-2"
        [class.zx-border-top-gray-25-pr]="i !== 0" [class.align-items-end]="!isRTL">
        <!-- =========== title =========== -->
        <b class="zx-text-sm-white zx-text-small pb-1" [class.zx-ltr]="!isRTL" [class.px-lg-3]="property === 'pricing'">
            {{ "paper-type.name." + paper.serial_name | translate }}
        </b>
        <!-- // =========== title =========== -->

        <!-- =========== paper =========== -->
        <div *ngIf="property === 'paper'" class="w-100 d-flex flex-column gap-1">
            <div class="w-100 d-flex align-items-center justify-content-between" [class.flex-row-reverse]="!isRTL">
                <span class="zx-text-sm-white zx-text-tiny">
                    {{ "su-management.branches_paper-width" | translate }}
                </span>
                <span class="zx-text-sm-white zx-text-tiny" [class.zx-ltr]="!isRTL">
                    <span>
                        {{ expressPapers[i].paperWidth }}
                    </span>
                    <span>
                        {{ "printing-table.dimensions-cm" | translate }}
                    </span>
                </span>
            </div>
            <div class="w-100 d-flex align-items-center justify-content-between" [class.flex-row-reverse]="!isRTL">
                <span class="zx-text-sm-white zx-text-tiny">
                    {{ "su-management.branches_paper-height" | translate }}
                </span>
                <span class="zx-text-sm-white zx-text-tiny" [class.zx-ltr]="!isRTL">
                    <span>
                        {{ expressPapers[i].paperHeight }}
                    </span>
                    <span>
                        {{ "printing-table.dimensions-cm" | translate }}
                    </span>
                </span>
            </div>
            <div class="w-100 d-flex align-items-center justify-content-between" [class.flex-row-reverse]="!isRTL">
                <span class="zx-text-sm-white zx-text-tiny">
                    {{ "su-management.branches_paper-weight" | translate }}
                </span>
                <span class="zx-text-sm-white zx-text-tiny" [class.zx-ltr]="!isRTL">
                    <span>
                        {{ expressPapers[i].paperWeight }}
                    </span>
                    <span>
                        {{ "su-management.branches_paper-weight-g" | translate }}
                    </span>
                </span>
            </div>
            <span class="zx-text-sm-white zx-text-tiny pt-1" [class.zx-ltr]="!isRTL" [class.text-start]="!isRTL">
                {{ "paper-type.description." + paper.serial_name | translate }}
            </span>
        </div>
        <!-- // =========== paper =========== -->

        <!-- =========== pricing =========== -->
        <div *ngIf="property === 'pricing'"
            class="w-100 d-flex flex-column align-items-center shadow-85 rounded-2 py-2 mt-2 px-3">

            <!-- == prices [single color] == -->
            <div class="w-100 d-flex align-items-center justify-content-between" [class.flex-row-reverse]="!isRTL">
                <!-- properties -->
                <div class="d-flex flex-column flex-lg-row gap-1 gap-lg-2">
                    <!-- sides -->
                    <div *ngIf="isDubbleSidedPaper(paper)" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            {{ "printing-table.sides-one" | translate }}
                        </span>
                    </div>
                    <!-- color -->
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            {{ "printing-table.color-color" | translate }}
                        </span>
                    </div>
                </div>
                <!-- prices -->
                <div class="d-flex flex-column flex-lg-row gap-1 gap-lg-2">
                    <span class="zx-text-sm-white zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                            {{ realBranch.express?.pricing?.x }}
                        </span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                            {{ "su-management.report.prices.first-pages" | translate }}
                        </span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                            class="opacity-50">:</span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                            class="zx-100-opp">-</span>
                        <b>
                            {{ getPaperPriceExpress(paper.paperName, 'first', 'single', 'color') }}
                        </b>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "printing-table.nis" | translate }}
                        </span>
                    </span>
                    <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                        class="zx-text-sm-white zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span class="opacity-50">
                            {{ "su-management.report.prices.extra-pages" | translate }}
                        </span>
                        <span class="opacity-50">:</span>
                        <span class="zx-100-opp">-</span>
                        <b>
                            {{ getPaperPriceExpress(paper.paperName, 'more', 'single', 'color') }}
                        </b>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "printing-table.nis" | translate }}
                        </span>
                    </span>
                </div>
            </div>
            <div class="d-flex w-100 zx-border-bottom-gray-v-light-mid my-2 my-lg-1"></div>
            <!-- == prices [single bw] == -->
            <div class="w-100 d-flex align-items-center justify-content-between" [class.flex-row-reverse]="!isRTL">
                <!-- properties -->
                <div class="d-flex flex-column flex-lg-row gap-1 gap-lg-2">
                    <!-- sides -->
                    <div *ngIf="isDubbleSidedPaper(paper)" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            {{ "printing-table.sides-one" | translate }}
                        </span>
                    </div>
                    <!-- color -->
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            {{ "printing-table.color-bandw" | translate }}
                        </span>
                    </div>
                </div>
                <!-- prices -->
                <div class="d-flex flex-column flex-lg-row gap-1 gap-lg-2">
                    <span class="zx-text-sm-white zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                            {{ realBranch.express?.pricing?.x }}
                        </span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                            {{ "su-management.report.prices.first-pages" | translate }}
                        </span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                            class="opacity-50">:</span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                            class="zx-100-opp">-</span>
                        <b>
                            {{ getPaperPriceExpress(paper.paperName, 'first', 'single', 'bw') }}
                        </b>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "printing-table.nis" | translate }}
                        </span>
                    </span>
                    <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                        class="zx-text-sm-white zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span class="opacity-50">
                            {{ "su-management.report.prices.extra-pages" | translate }}
                        </span>
                        <span class="opacity-50">:</span>
                        <span class="zx-100-opp">-</span>
                        <b>
                            {{ getPaperPriceExpress(paper.paperName, 'more', 'single', 'bw') }}
                        </b>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "printing-table.nis" | translate }}
                        </span>
                    </span>
                </div>
            </div>
            <div *ngIf="isDubbleSidedPaper(paper)" class="d-flex w-100 zx-border-bottom-gray-v-light-mid my-2 my-lg-1">
            </div>
            <!-- == prices [double color] == -->
            <div *ngIf="isDubbleSidedPaper(paper)" class="w-100 d-flex align-items-center justify-content-between"
                [class.flex-row-reverse]="!isRTL">
                <!-- properties -->
                <div class="d-flex flex-column flex-lg-row gap-1 gap-lg-2">
                    <!-- sides -->
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            {{ "printing-table.sides-two" | translate }}
                        </span>
                    </div>
                    <!-- color -->
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            {{ "printing-table.color-color" | translate }}
                        </span>
                    </div>
                </div>
                <!-- prices -->
                <div class="d-flex flex-column flex-lg-row gap-1 gap-lg-2">
                    <span class="zx-text-sm-white zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                            {{ realBranch.express?.pricing?.x }}
                        </span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                            {{ "su-management.report.prices.first-pages" | translate }}
                        </span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                            class="opacity-50">:</span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                            class="zx-100-opp">-</span>
                        <b>
                            {{ getPaperPriceExpress(paper.paperName, 'first', 'double', 'color') }}
                        </b>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "printing-table.nis" | translate }}
                        </span>
                    </span>
                    <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                        class="zx-text-sm-white zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span class="opacity-50">
                            {{ "su-management.report.prices.extra-pages" | translate }}
                        </span>
                        <span class="opacity-50">:</span>
                        <span class="zx-100-opp">-</span>
                        <b>
                            {{ getPaperPriceExpress(paper.paperName, 'more', 'double', 'color') }}
                        </b>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "printing-table.nis" | translate }}
                        </span>
                    </span>
                </div>
            </div>
            <div *ngIf="isDubbleSidedPaper(paper)" class="d-flex w-100 zx-border-bottom-gray-v-light-mid my-2 my-lg-1">
            </div>
            <!-- == prices [double bw] == -->
            <div *ngIf="isDubbleSidedPaper(paper)" class="w-100 d-flex align-items-center justify-content-between"
                [class.flex-row-reverse]="!isRTL">
                <!-- properties -->
                <div class="d-flex flex-column flex-lg-row gap-1 gap-lg-2">
                    <!-- sides -->
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            {{ "printing-table.sides-two" | translate }}
                        </span>
                    </div>
                    <!-- color -->
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            {{ "printing-table.color-bandw" | translate }}
                        </span>
                    </div>
                </div>
                <!-- prices -->
                <div class="d-flex flex-column flex-lg-row gap-1 gap-lg-2">
                    <span class="zx-text-sm-white zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                            {{ realBranch.express?.pricing?.x }}
                        </span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                            {{ "su-management.report.prices.first-pages" | translate }}
                        </span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                            class="opacity-50">:</span>
                        <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                            class="zx-100-opp">-</span>
                        <b>
                            {{ getPaperPriceExpress(paper.paperName, 'first', 'double', 'bw') }}
                        </b>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "printing-table.nis" | translate }}
                        </span>
                    </span>
                    <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                        class="zx-text-sm-white zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span class="opacity-50">
                            {{ "su-management.report.prices.extra-pages" | translate }}
                        </span>
                        <span class="opacity-50">:</span>
                        <span class="zx-100-opp">-</span>
                        <b>
                            {{ getPaperPriceExpress(paper.paperName, 'more', 'double', 'bw') }}
                        </b>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "printing-table.nis" | translate }}
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <!-- // =========== pricing =========== -->

    </div>
</div>